// extracted by mini-css-extract-plugin
export default {"control":"StaysCheckout_control__EO8Q9","wrapper":"StaysCheckout_wrapper__Lzdk4","confirm":"StaysCheckout_confirm__NTrku","price":"StaysCheckout_price__h3fcz"};